class MediaCentralUrl {
  // We're expecting a URL like "http://g-ecx.images-amazon.com/images/G/01/rnh/test/C.jpg"
  constructor(url) {
    this.url = url;
  }

  // See https://w.amazon.com/index.php/MSA/HowTo/ImageStyleCodes for available style tags.
  applyStyle(tag) {
    const components = this.url.split('.');

    if (components.length < 2) {
      // Can't apply style tags to an invalid image url.
      return;
    }

    // If the URL already has a style code e.g. _XX100_
    // then append the new style tag to the existing tag, otherwise we
    // need to append ._XX100_ after the image file name and before the extension.
    if (/^_.*_$/.test(components[components.length - 2])) {
      components[components.length - 2] += `${tag}_`;
    } else {
      components.splice(-1, 0, `_${tag}_`);
    }

    this.url = components.join('.');
  }

  static isNonZeroNumber(num) {
    return (typeof num === 'number' && num > 0);
  }

  static isNonNegativeNumber(num) {
    return (typeof num === 'number' && num >= 0);
  }

  scaleX(x) {
    if (MediaCentralUrl.isNonZeroNumber(x)) {
      this.applyStyle(`UX${x.toString()}`);
    }
  }

  scaleY(y) {
    if (MediaCentralUrl.isNonZeroNumber(y)) {
      this.applyStyle(`UY${y.toString()}`);
    }
  }

  crop(x, y, width, height) {
    if (MediaCentralUrl.isNonNegativeNumber(x) && MediaCentralUrl.isNonNegativeNumber(y)
      && MediaCentralUrl.isNonZeroNumber(width) && MediaCentralUrl.isNonZeroNumber(height)) {
      this.applyStyle(`CR${x.toString()},${y.toString()},${width.toString()},${height.toString()}`);
    }
  }

  toString() {
    return this.url;
  }
}

export default MediaCentralUrl;
